<script setup>
  import { useStore } from 'vuex'
  import { computed, ref } from 'vue'

  const store = useStore();
  const userGrade = computed(() => store.getters['bookFair/grade'])
  const userField = computed(() => store.getters['bookFair/field'])
  const hasField = ref(false)
  // Holds selected grade value(s) for radio highlighting
  const selectedGradeValues = ref(null)
  const selectGrade = (gradeItem) => {
    store.commit('bookFair/CHANGE_GRADE_STATE', gradeItem)
    selectedGradeValues.value = gradeItem.value
    hasField.value = !!gradeItem.hasField
    if (!gradeItem.hasField) {
      store.state.bookFair.drawer = false
    }
  }

  // Field selection handler
  const selectField = (fieldItem) => {
    store.commit('bookFair/CHANGE_FIELD_STATE', fieldItem)
    hasField.value = false
    store.state.bookFair.drawer = false
  }

</script>

<template>
  <v-app class="book-fair-bg">
    <v-navigation-drawer v-model="store.state.bookFair.drawer" color="#032AB3">
      <template #prepend>

      </template>
      <v-slide-x-transition leave-absolute hide-on-leave>
        <v-list
          v-if="!hasField"
          bg-color="transparent"
          v-model:selected="selectedGradeValues"
          selectable
          max-height="250"
          class="px-3"
        >
          <v-list-item
            title="انتخاب پایه"
            class="text-white mt-10"
            rounded="xl"
            @click="store.state.bookFair.drawer = false"
          >
            <template #prepend>
              <v-icon icon="$close" />
            </template>
          </v-list-item>
          <v-list-item
            v-for="(grade, index) in store.state.bookFair.grades"
            :key="`grade-${index}`"
            :title="grade.title"
            :value="grade.value"
            class="text-white"
            rounded="xl"
            @click="selectGrade(grade)"
          >
            <template v-if="grade.hasField" #append>
              <v-icon icon="$mdiChevronLeft" />
            </template>
          </v-list-item>
        </v-list>

        <v-list v-else bg-color="transparent" max-height="250"  class="px-3">
          <v-list-item
            title="انتخاب رشته"
            class="text-white mt-10"
            rounded="xl"
            @click="hasField = false"
          >
            <template #prepend>
              <v-icon icon="$chevronRight" />
            </template>
          </v-list-item>
          <v-list-item
            v-for="(field, index) in store.state.bookFair.fields"
            :key="`field-${index}`"
            :title="field.title"
            :value="field.value"
            class="text-white"
            rounded="xl"
            @click="selectField(field)"
          />
        </v-list>
      </v-slide-x-transition>
    </v-navigation-drawer>
    <v-main class="">
      <router-view v-slot="{ Component, route }">
        <v-slide-x-transition hide-on-leave>
          <component :is="Component" :key="route.path"  />
        </v-slide-x-transition>
      </router-view>
    </v-main>
  </v-app>
</template>

<style scoped lang="scss">
* {
  font-family: IranSans!important;
}
.book-fair-bg {
  background: linear-gradient(103deg, #032AB3 0%, #010A31 100%)!important;
}
</style>